import { Outlet } from "react-router-dom";

const AsteraOncologyExternalLayout = () => {
  return (
    <div className="pharma-submission__layout flex h-full w-full overflow-hidden">
      <div className="pharma-submission__outlet w-full flex-1">
        <Outlet />
      </div>
    </div>
  );
};

export default AsteraOncologyExternalLayout;
